export default __webpack_public_path__ + "images/8152f07dbdf76b162108bea802f5d5fc.svg";